import type { AppIconProps } from "../IconTypes";

export const DotsIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66675 8.49992C2.66675 8.67673 2.73699 8.8463 2.86201 8.97132C2.98703 9.09635 3.1566 9.16659 3.33341 9.16659C3.51023 9.16659 3.67979 9.09635 3.80482 8.97132C3.92984 8.8463 4.00008 8.67673 4.00008 8.49992C4.00008 8.32311 3.92984 8.15354 3.80482 8.02851C3.67979 7.90349 3.51023 7.83325 3.33341 7.83325C3.1566 7.83325 2.98703 7.90349 2.86201 8.02851C2.73699 8.15354 2.66675 8.32311 2.66675 8.49992Z"
        fill="#59C69E"
      />
      <path
        d="M7.33341 8.49992C7.33341 8.67673 7.40365 8.8463 7.52868 8.97132C7.6537 9.09635 7.82327 9.16659 8.00008 9.16659C8.17689 9.16659 8.34646 9.09635 8.47149 8.97132C8.59651 8.8463 8.66675 8.67673 8.66675 8.49992C8.66675 8.32311 8.59651 8.15354 8.47149 8.02851C8.34646 7.90349 8.17689 7.83325 8.00008 7.83325C7.82327 7.83325 7.6537 7.90349 7.52868 8.02851C7.40365 8.15354 7.33341 8.32311 7.33341 8.49992Z"
        fill="#59C69E"
      />
      <path
        d="M12.0001 8.49992C12.0001 8.67673 12.0703 8.8463 12.1953 8.97132C12.3204 9.09635 12.4899 9.16659 12.6667 9.16659C12.8436 9.16659 13.0131 9.09635 13.1382 8.97132C13.2632 8.8463 13.3334 8.67673 13.3334 8.49992C13.3334 8.32311 13.2632 8.15354 13.1382 8.02851C13.0131 7.90349 12.8436 7.83325 12.6667 7.83325C12.4899 7.83325 12.3204 7.90349 12.1953 8.02851C12.0703 8.15354 12.0001 8.32311 12.0001 8.49992Z"
        fill="#59C69E"
      />
      <path
        d="M2.66675 8.49992C2.66675 8.67673 2.73699 8.8463 2.86201 8.97132C2.98703 9.09635 3.1566 9.16659 3.33341 9.16659C3.51023 9.16659 3.67979 9.09635 3.80482 8.97132C3.92984 8.8463 4.00008 8.67673 4.00008 8.49992C4.00008 8.32311 3.92984 8.15354 3.80482 8.02851C3.67979 7.90349 3.51023 7.83325 3.33341 7.83325C3.1566 7.83325 2.98703 7.90349 2.86201 8.02851C2.73699 8.15354 2.66675 8.32311 2.66675 8.49992Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33341 8.49992C7.33341 8.67673 7.40365 8.8463 7.52868 8.97132C7.6537 9.09635 7.82327 9.16659 8.00008 9.16659C8.17689 9.16659 8.34646 9.09635 8.47149 8.97132C8.59651 8.8463 8.66675 8.67673 8.66675 8.49992C8.66675 8.32311 8.59651 8.15354 8.47149 8.02851C8.34646 7.90349 8.17689 7.83325 8.00008 7.83325C7.82327 7.83325 7.6537 7.90349 7.52868 8.02851C7.40365 8.15354 7.33341 8.32311 7.33341 8.49992Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 8.49992C12.0001 8.67673 12.0703 8.8463 12.1953 8.97132C12.3204 9.09635 12.4899 9.16659 12.6667 9.16659C12.8436 9.16659 13.0131 9.09635 13.1382 8.97132C13.2632 8.8463 13.3334 8.67673 13.3334 8.49992C13.3334 8.32311 13.2632 8.15354 13.1382 8.02851C13.0131 7.90349 12.8436 7.83325 12.6667 7.83325C12.4899 7.83325 12.3204 7.90349 12.1953 8.02851C12.0703 8.15354 12.0001 8.32311 12.0001 8.49992Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
